import { httpPublic2 } from "@/api/public";

import * as actionTypes from "./actionTypes";

export const updateInsuranceList = (data) => {
  return {
    payload: {
      insuranceList: data,
    },
    type: actionTypes.UPDATE_INSURANCE_LIST,
  };
};

// ----------- Thunks --------------

export const fetchInsuranceList = (context) => (dispatch) => {
  return httpPublic2
    .post("/v2/patient/insurance", { context })
    .json()
    .then((data) => {
      dispatch(updateInsuranceList(data));

      return data;
    });
};
